export const PROFILER_IMAGE_BASE_URL = 'https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images';
export const BENEFIT_ICON_URL = 'https://d2djimvzddgguw.cloudfront.net/humbee-benefit-icons' ;

export const PROFILER_BRAND_IMAGE_URL = 'https://d2djimvzddgguw.cloudfront.net/humbee_profiler/brands';

export const PROFILER_IMAGES = {
  bcm: `${PROFILER_IMAGE_BASE_URL}/shilpkar.png`,
  
  fmcg: `${PROFILER_IMAGE_BASE_URL}/basket.png`,
  fridge: `${PROFILER_IMAGE_BASE_URL}/fridge.png`,
  
  li: `${BENEFIT_ICON_URL}/life_insurance.svg`,
  mi: `${BENEFIT_ICON_URL}/medical_insurance.svg`,
  gap: `${BENEFIT_ICON_URL}/gap.svg`,
  
  nextGen: `${PROFILER_IMAGE_BASE_URL}/next-gen.png`,
  
  turnoverBcm: `${PROFILER_IMAGE_BASE_URL}/turn_over_bcm.png`,
  turnoverFmcg: `${PROFILER_IMAGE_BASE_URL}/turn_over_fmcg.png`,
  
  married: `${PROFILER_IMAGE_BASE_URL}/married.png`,
  ring: `${PROFILER_IMAGE_BASE_URL}/ring.png`,
  single: `${PROFILER_IMAGE_BASE_URL}/single.png`,


  adhyayan: `${PROFILER_IMAGE_BASE_URL}/adhyayan.png`,
  kids_count: `${PROFILER_IMAGE_BASE_URL}/Kids.png`,  
  kids_education_count: `${PROFILER_IMAGE_BASE_URL}/kids_education.png`,

  holiday_preference: `${PROFILER_IMAGE_BASE_URL}/holiday_preference.png`,
  tajmahal: `${PROFILER_IMAGE_BASE_URL}/taj_mahal.png`,
  indiaMap: `${PROFILER_IMAGE_BASE_URL}/india_map.png`,
  
  preffered_language: `${PROFILER_IMAGE_BASE_URL}/preferred_language.png`,

  // brands
  cement: `${PROFILER_BRAND_IMAGE_URL}/cement.png`,
  electrical_supplies: `${PROFILER_BRAND_IMAGE_URL}/electrical-supplies.png`,
  erp_pipes: `${PROFILER_BRAND_IMAGE_URL}/erp-pipes.png`,
  paint: `${PROFILER_BRAND_IMAGE_URL}/paint.png`,
  plywood: `${PROFILER_BRAND_IMAGE_URL}/plywood.png`,
  steel_angles: `${PROFILER_BRAND_IMAGE_URL}/steel-angles.png`,
  steel_tmt: `${PROFILER_BRAND_IMAGE_URL}/steel-tmt.png`,
  tile_adhesive: `${PROFILER_BRAND_IMAGE_URL}/tile-adhesive.png`,
};

export const cardStyles = (props = {}) => ({
  width: props.width || '100%',
  minHeight: '348px',
  maxWidth: props.maxWidth || { xs: 250, md: 300 },
  borderRadius: 2,
  backgroundColor: '#FFFFFF',
  p: { xs: 2, md: 2 },
  display: 'flex',
  flexShrink: 0,
  ...props,
});
